import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import { requiredValidator, passwordValidator, passwordsMatch, emailValidator } from 'utils/validators';
import RenderFormInput from 'components/forms/RenderFormInput';
import Checkbox from 'components/forms/Checkbox';
import Button from 'components/buttons/Button';
import GoogleLogin from 'react-google-login';
import { connect } from 'react-redux';
import { googleLogin } from 'redux/actions/userActions';
import { first } from 'lodash';
import { notification, defaultNoticeConfig } from 'utils/notifications';
import BasicNotification from 'components/Notification';
import Error from 'components/forms/Error';
import { GOOGLE_CLIENT_ID } from '../constants/config';


const styles = theme => ({
  title: {
    fontWeight: 600,
    fontSize: '2rem',
  },
  signUp: {
    fontWeight: 500,
    fontSize: '14px',
    width: '100%',
  },
  signUpLink: {
    color: `${theme.palette.primary.main} !important`,
  },
  forgotPassword: {
    fontWeight: 500,
    fontSize: '14px',
    width: '100%',
    marginTop: '1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  forgotPasswordLink: {
    color: `${theme.palette.primary.main} !important`,
  },
  fullNameGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '100%',
  },
  termsAndConditionsWrapper: {
    display: 'flex',
    fontSize: '0.75rem',
    fontWeight: 400,
    alignItems: 'end',
    width: '18.75rem',
    marginLeft: '-0.5rem',
    '& > div > a': {
      color: theme.palette.primary.main,
    },
  },
  loginBtn: {
    width: '156px',
  },
  googleLoginBtn: {
    width: '100%',
    height: '3rem !important',
    justifyContent: 'center',
    boxShadow: 'none !important',
    borderRadius: '0.375rem !important',
    border: '0.063rem solid !important',
    borderColor: `${theme.palette.secondary['300']} !important`,
    '& span': {
      color: `${theme.palette.gray.text} !important`,
      fontWeight: '600 !important',
      letterSpacing: '0.065rem',
      opacity: '0.9',
    },
    '&:hover': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
    '&:active': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  },
  divider: {
    width: '100%',
    color: theme.palette.gray.text,
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '0.875rem',
    letterSpacing: '0.04rem',
    marginTop: '1.5rem',
  },
});

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    classes: PropTypes.element.isRequired,
    isSignUp: PropTypes.bool,
    subscription: PropTypes.shape({}).isRequired,
    googleLogin: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isSignUp: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      termsAndConditionsError: '',
    };
    this.checkboxRef = React.createRef();
  }

  onSubmit = (values) => {
    const { handleSubmit, isSignUp } = this.props;
    if (isSignUp && !this.checkboxRef.current.checked) {
      this.setState({ termsAndConditionsError: 'You must accept the terms and conditions first' });
      values.preventDefault();
      values.stopPropagation();
      return;
    }
    this.setState({ termsAndConditionsError: '' });
    handleSubmit(values);
  }

  onGoogleLoginSuccess = async (res) => {
    const { isSignUp } = this.props;
    try {
      await this.props.googleLogin({ access_token: res.accessToken });
      if (isSignUp) {
        this.props.history.push('/dashboard');
      }
    } catch (error) {
      if (error instanceof SubmissionError) {
        notification.notice({
          content: <BasicNotification
            color="danger"
            message={first(first(Object.values(error.errors)))}
          />,
          ...defaultNoticeConfig,
        });
      }
    }
  }

  onGoogleLoginFailure = (res) => {
    // eslint-disable-next-line no-console
    console.error(res);
    notification.notice({
      content: <BasicNotification
        color="danger"
        message={res.error ? `${res.error}: ${res.detail}` : 'Something went wrong, please contact support'}
      />,
      ...defaultNoticeConfig,
    });
  }

  render() {
    const { classes, isSignUp } = this.props;

    return (
      <form className="form" onSubmit={this.onSubmit}>
        <h1 className={classes.title}>{isSignUp ? 'Get started with PR Volt' : 'Login to PR Volt'}</h1>
        {isSignUp && (
          <div className={classes.signUp}>
            Already have an account?
            <a className={classes.signUpLink} href="/login"> Sign in</a>
          </div>
        )}
        {!isSignUp && (
          <>
            <div className="form__form-group-field">
              <GoogleLogin
                clientId={GOOGLE_CLIENT_ID}
                buttonText="Log In With Google"
                onSuccess={this.onGoogleLoginSuccess}
                onFailure={this.onGoogleLoginFailure}
                cookiePolicy="single_host_origin"
                className={classes.googleLoginBtn}
              />
            </div>
            <div className={classes.divider}>or</div>
          </>
        )}
        {/* <div className={classes.signUp}>
            Don&#39;t have an account yet?
            <a className={classes.signUpLink} href="https://www.prvolt.com/pricing"> Sign up</a>
          </div> */}
        {isSignUp && (
        <div className={classes.fullNameGroup}>
          <div className="form__form-group mt-4">
            <span className="form__form-group-label">First Name</span>
            <div className="form__form-group-field">
              <Field
                name="firstName"
                component={RenderFormInput}
                type="text"
                label="Manuel"
                validate={[requiredValidator]}
              />
            </div>
          </div>
          <div className="form__form-group mt-4">
            <span className="form__form-group-label">Last Name</span>
            <div className="form__form-group-field">
              <Field
                name="lastName"
                component={RenderFormInput}
                type="text"
                label="Vargas"
                validate={[requiredValidator]}
              />
            </div>
          </div>
        </div>
          )}
        <div className="form__form-group mt-4">
          <span className="form__form-group-label">Email</span>
          <div className="form__form-group-field">
            <Field
              name="email"
              component={RenderFormInput}
              type="text"
              label="Email"
              validate={[requiredValidator, emailValidator]}
            />
          </div>
        </div>
        {isSignUp && (
            <>
              <div className="form__form-group mt-4">
                <span className="form__form-group-label">Company</span>
                <div className="form__form-group-field">
                  <Field
                    name="company"
                    component={RenderFormInput}
                    type="text"
                    label="Company name"
                    validate={[requiredValidator]}
                  />
                </div>
              </div>
              <div className="form__form-group mt-4">
                <span className="form__form-group-label">Phone</span>
                <div className="form__form-group-field">
                  <Field
                    name="phone"
                    component={RenderFormInput}
                    type="tel"
                    label="Phone number"
                    validate={[requiredValidator]}
                  />
                </div>
              </div>
            </>
          )}
        <div className="form__form-group mt-4">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <Field
              name="password"
              component={RenderFormInput}
              type="password"
              label="Password"
              validate={[requiredValidator, ...isSignUp ? [passwordValidator] : []]}
            />
          </div>
        </div>
        {isSignUp && (
        <div className="form__form-group mt-4">
          <span className="form__form-group-label">Confirm Password</span>
          <div className="form__form-group-field">
            <Field
              name="confirmPassword"
              component={RenderFormInput}
              type="password"
              label="Confirm password"
              validate={[requiredValidator, passwordValidator, passwordsMatch]}
            />
          </div>
        </div>
          )}
        <div className={classes.forgotPassword}>
          <div>
            {isSignUp
              ? (
                <>
                  <div className={classes.termsAndConditionsWrapper}>
                    <Checkbox inputRef={this.checkboxRef} />
                    <div>
                      By creating an account you agree to our&nbsp;
                      <a
                        href="https://www.prvolt.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >Privacy Policy
                      </a>{' '}
                      and&nbsp;
                      <a
                        href="https://www.prvolt.com/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                      >Terms &amp; Conditions
                      </a>
                    </div>
                  </div>
                  <Error error={this.state.termsAndConditionsError} />
                </>
              )
              : <>Forgot your password? <a className={classes.forgotPasswordLink} href="/forgot">Reset</a></>
            }
          </div>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            size="large"
            className={classes.loginBtn}
          >
            {isSignUp ? 'Sign Up' : 'Sign In'}
          </Button>
        </div>
      </form>
    );
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(
    (state) => {
      const { chargebee_data: chargebeeData } = state.subscription;
      return ({
        initialValues: {
          firstName: chargebeeData.first_name,
          lastName: chargebeeData.last_name,
          company: chargebeeData.company,
          email: chargebeeData.email,
          phone: chargebeeData.phone,
        },
      });
    },
    { googleLogin },
  ),
  reduxForm({
    form: 'log_in_form', // a unique identifier for this form
  }),
)(LogInForm);
